import {Pipe, PipeTransform} from "@angular/core";
import {LoggerService} from "../../shared/logger.service";
import {LieferantenGruppe} from "../../shared/lieferantengruppe.model";
import { FormControl } from "@angular/forms";
const PATH_FILE='app/protected/verwaltungfragebogen/datapipelieferantengruppe.ts';
@Pipe({
	name: 'dataPipeLieferantengruppe',
	standalone:true
})
export class DataTablePipeLieferantenGruppe implements PipeTransform {
	constructor(private _logger: LoggerService) { }
	transform(array: LieferantenGruppe[], query: FormControl): LieferantenGruppe[] {
		this._logger.log(PATH_FILE + ' - transform BEGIN');
		this._logger.log(PATH_FILE + ' - transform array: ', array);
		this._logger.log(PATH_FILE + ' - transform query: ', query);
		if (query && query.value) {
			return array.filter((value: LieferantenGruppe, index: number, arr: LieferantenGruppe[]) =>
				value.name.toLowerCase().indexOf(query.value.toLowerCase()) > -1
			);
		}
		return array;
	} // transform
} // class DataTablePipe
